import {UserStateVo} from '../../common/shared/api/nicolas/vo/enums/UserStateVo.enum';
import {UserState} from '../generated/types';

export function createUserState(userStateVo?: UserStateVo): UserState {
  if (!userStateVo) return UserState.NeedLogin;
  return map[userStateVo];
}

const map: {[key in UserStateVo]: UserState} = {
  [UserStateVo.PreMember]: UserState.PreMember,
  [UserStateVo.NonMember]: UserState.NonMember,
  [UserStateVo.RegularMember]: UserState.RegularMember,
  [UserStateVo.LeaveMember]: UserState.LeaveMember,
  [UserStateVo.DormantAccount]: UserState.DormantAccount,
};
